export const USER_TYPE = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  USER: "USER",
};

export const PERMISSIONS = {
  MANAGE_SOR: "esor.manage_sor",
  INPUT_SOR: "esor.input_sor",
  CREATE_CONTRACT: "esor.create_contract",
  MANAGE_CONTRACT: "esor.manage_contract",
  MANAGE_NSR: "esor.manage_nsr",
  MANAGE_NSR_IND: "esor.manage_nsr_ind",
  MANAGE_RBU_DATASET: "rbu.manage_dataset",
  MANAGE_RBU_EDITION: "rbu.manage_edition",
  MANAGE_RBU_TEMPLATE_VERIFICATION: "rbu.template_verification",
};

export const SPECIAL_PERMISSIONS = {
  ASOR_RBU: "ASOR_RBU",
};

export const SOR_TYPE = {
  SOR: "SOR",
  CORRIGENDUM: "CORRIGENDUM",
  A_SOR: "A_SOR",
};

export const WORK_NATURE = {
  FIX_ONLY: "FIX_ONLY",
  SUPPLY_ONLY: "SUPPLY_ONLY",
  SUPPLY_AND_FIX_AND_MISC: "SUPPLY_AND_FIX_AND_MISC",
  TD_AND_CLEAR_WAY: "TD_AND_CLEAR_WAY",
  TD_AND_SET_ASIDE_FOR_REUSE: "TD_AND_SET_ASIDE_FOR_REUSE",
  EXTRA_OVER: "EXTRA_OVER",
};

export const DIMBOOK_ADJUSTMENT = {
  ORIGINAL: "O",
  INSERT: "I",
  UPDATE: "U",
  DELETE: "D",
};

export const UNIT_ID = {
  CUBIC: "A",
  SQUARE: "B",
  LINEAR: "C",
  WEIGHT: "D",
  PER_ITEM: "E",
};

export const RBU_ITEM_MODULE_CATEGORY = {
  LABOUR: "LABOUR",
  MATERIAL: "MATERIAL",
  OTHER: "OTHER",
};

export const RBU_MODULE_BASE_RATE_TYPE = {
  TENDER_RATES: "TENDER_RATES",
  DATAPOINT: "DATAPOINT",
  PAST_SOR_RATE: "PAST_SOR_RATE",
};

export const RBU_MODULE_TENDER_RATE_MODE = {
  AVERAGE: "AVERAGE",
  SUM: "SUM",
};

export const RBU_MODULE_GROUP_VALUE_MODE = {
  AVERAGE: "AVERAGE",
  SUM: "SUM",
};

export const RBU_DATASET_VALUE_TYPE = {
  PRICE: "PRICE",
  INDEX: "INDEX",
};
